import store from "@/store";
export default async function authMiddleware(to, from, next) {
  const publicRoutes = ["Login", "RegisterUser", "RecoverPassword"];
  if (store.state.users.authChecking) {
    await new Promise((resolve) => {
      const unwatch = store.watch(
        (state) => state.users.authChecking,
        (checking) => {
          if (!checking) {
            unwatch();
            resolve();
          }
        }
      );
    });
  }

  const isAuthenticated = !!store.state.users.user;

  if (isAuthenticated && publicRoutes.includes(to.name)) {
    return next({ name: "MainPage" });
  }

  if (publicRoutes.includes(to.name)) {
    return next();
  }

  if (!isAuthenticated) {
    return next({ name: "Login" });
  }

  next();
}
